import { createReducer, on } from '@ngrx/store';
import { StatisticsCountDto } from '@smmof/dto';
import { StatisticsActions } from '../actions/statistics.actions';

export interface StatisticsState {
  statistics: StatisticsCountDto | null;
  loading: boolean;
  error: any;
}

export const initialState: StatisticsState = {
  statistics: null,
  loading: false,
  error: null,
};

export const statisticsReducer = createReducer(
  initialState,
  on(StatisticsActions.getStatistics, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(StatisticsActions.getStatisticsSuccess, (state, { statistics }) => ({
    ...state,
    statistics,
    loading: false,
    error: null,
  })),
  on(StatisticsActions.getStatisticsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
